import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import routingService from 'common/src/modules/routing/routing.service';
import {CLStore} from 'common/src/redux/store';
import generalAgent from '../agents/generalAgent';
import currentRouteContext from '../contexts/currentRouteContext/currentRouteContext';
import generalContext from '../contexts/generalContext';
import copilotSkillsAgent from '../skills__agents/copilotSkillsAgent';
import supportSkillsAgent from '../skills__agents/supportSkillsAgent';
import {registerSkill} from '../skills';
import generalNavigationSkill from '../skills/definitions/generalNavigationSkill/generalNavigationSkill';
import generalNavigationTool from '../tools/generalNavigationTool/generalNavigationTool';
import getFilesTool from '../tools/getFilesTool';

export default function initializeCopilot(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.FlightControl, {
    description: '',
    contexts: [generalContext, currentRouteContext(store.getState)],
  });
  const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

  if (isSkillsMode) {
    _initializeInSkillsMode(store);
  } else {
    copilot.registerAgent(generalAgent(store));
  }
}

function _initializeInSkillsMode(store: CLStore) {
  routingService.initializeHistoryTracking();

  copilot.tools.registerUniversalTools([getFilesTool(), generalNavigationTool(store.getState)]);
  registerSkill(generalNavigationSkill(store));
  copilot.setGeneralAgent(copilotSkillsAgent(store));
  copilot.setSupportAgent(supportSkillsAgent(store));
}
